module.exports = ".assets-grid-loading {\n  position: absolute;\n  left: 50%;\n  padding-top: 21vh; }\n"